import { intParamTransform } from './url-param-transform';
import { useUrlParam } from './use-url-param';
export function useUrlBuildingParam(defaultMode, defaultCategory = 'categories') {
    return useUrlParam('building', intParamTransform, '/:mode/:category/:building?/(history)?', { mode: defaultMode, category: defaultCategory });
}
